/* import __COLOCATED_TEMPLATE__ from './set-ticket-custom-state.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type TicketStateService from 'embercom/services/ticket-state-service';
import { type MacroAction } from 'embercom/objects/inbox/macro';

interface Signature {
  Args: { action: MacroAction };
}

export default class SetTicketCustomState extends Component<Signature> {
  @service declare ticketStateService: TicketStateService;

  get label() {
    let id = this.args.action.data?.ticket_custom_state_id;
    if (id === undefined) {
      return '';
    }
    let matchedState = this.ticketStateService.getTicketCustomStateById(id);
    return matchedState?.adminLabel || '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::UseMacro::Preview::SetTicketCustomState': typeof SetTicketCustomState;
    'inbox2/command-k/use-macro/preview/set-ticket-custom-state': typeof SetTicketCustomState;
  }
}
